<template>
  <div class="maintenance">
    maintenance
  </div>
</template>

<script>
export default {
  name: "maintenance",
  data() {
    return {
      msg: ""
    }
  },
  components: {
    //someComponent
  },
  methods: {
    //
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.maintenance {

}
</style>